module.exports = __webpack_public_path__ + "static/media/home-affiliate.90fc9e05.png";